/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/encourage_hate_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M15.842 25.475C14.686 25.089 12.5 23.658 12.5 21c0-1.889 1.06-2.754 1.91-3.449.696-.566 1.09-.92 1.09-1.551 0-1.658-1.708-2.545-1.725-2.554l.448-.894C14.316 12.6 16.5 13.717 16.5 16c0 1.137-.774 1.77-1.457 2.326-.794.649-1.543 1.26-1.543 2.674 0 2.594 2.551 3.489 2.659 3.525l-.317.95zm1.021-5.016l-.396-.918c.083-.036 2.033-.926 2.033-3.541 0-1.465-.814-2.402-1.604-3.309C16.21 11.902 15.5 11.086 15.5 10c0-2.182 1.1-3.307 1.146-3.354l.707.707c-.033.034-.853.901-.853 2.647 0 .712.533 1.325 1.15 2.035.824.947 1.85 2.127 1.85 3.965 0 3.292-2.529 4.414-2.637 4.459z"/>'
  }
})
